<div class="container">
  <!-- Título -->
  <p class="header-text">
    {{ 'ACCESSCONTROLBOOK.ASIDE.SELECTCOLUMNSTEXT' | translate }}
  </p>

  <!-- Buscador y Botón -->
  <div class="search-actions">
    <input type="text" class="searchbox" placeholder="{{ 'SEARCH' | translate }}" [(ngModel)]="searchText"
      (ngModelChange)="onSearchChange()" />

    <button class="toggle-button action" (click)="toggleSelection()">
      {{ areAllFilteredSelected() ? ('ACCESSCONTROLBOOK.ASIDE.NOSELECTALL' | translate) :
      ('ACCESSCONTROLBOOK.ASIDE.SELECTALL' | translate) }}
    </button>

  </div>

  <!-- Tabla scrollable -->
  <div class="table-scroll" *ngIf="items">
    <table class="columns-table">
      <tbody>
        <tr *ngFor="let item of filteredItems" class="table-row">
          <td class="column-checkbox-label">
            <boolean-component [(ngModel)]="checkedItems[items.indexOf(item)]" [readonly]="false"
              [placeholder]="item | translate" (valueChanged)="booleanChanged()">
            </boolean-component>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>